const e = ["button", "[focusable]", "[href]", "input", "label", "select", "textarea", "[tabindex]"], t = ':not([tabindex="-1"])', a = e.join(`${t}, `) + t, n = e.join(", ");
export {
  n as f,
  a as u
};
//# sourceMappingURL=focusable-selectors-BDDc1rUp.js.map
